import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Philosophy = () => {
  const location = useLocation();

  // main.jsx에서 /philosophy#brainshower이동 부분
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 이념`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);
  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/philosophy" className="sel">
                  아소비 이념
                </a>
              </li>
              <li>
                <a href="/learning">특허받은 학습법</a>
              </li>
              <li>
                <a href="/program">아소비 프로그램</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="philosophy">
          <div className="sect phil01 init">
            <div className="bg">
              <img src="../custom-resources/img/img_philosophy_phil01.jpg" alt="" />
            </div>
            <div className="wrap">
              <div className="img">
                <img
                  src="../custom-resources/img/img_philosophy_logo.png"
                  className="pc-view"
                  alt=""
                />
                <img
                  src="../custom-resources/img/img_philosophy_img.png"
                  className="mo-view"
                  alt=""
                />
              </div>
              <div className="tit init">
                우리 아이에게 <br />
                행복한 배움의 시작은 <br />
                유기농공부 아소비입니다.
              </div>
            </div>
          </div>
          <div className="sect phil02">
            <div className="wrap">
              <div className="tit init">
                아소비는 <p>유기농공부</p>입니다.
              </div>
              <div className="txt init">
                <p>
                  아소비는 머리만 똑똑한 아이가 아닌 몸과 마음, 정신이 <br />
                  모두 건강한 아이를 만들기 위해 노력합니다. <br />
                  우리 아이들에게 가장 필요한{" "}
                  <span className="highlight">학습생명력</span>을 주는 공부!
                </p>
                <p>
                  아소비에서는 유기농공부를 위해 <br />
                  <span className="neon init">
                    브레인 샤워, 쾌 학습, 걷는 교육
                  </span>
                  의 세 가지 방법을 실천합니다.
                </p>
              </div>
            </div>
          </div>
          <div className="sect phil03" id="brainshower">
            <div className="wrap">
              <div className="tit init">브레인 샤워</div>
              <div className="txt init">
                <p>
                  <span className="neon init">
                    기계적인 문제풀이와 반복학습, 무분별한 선행학습, 주입식 교육
                  </span>{" "}
                  등으로 <br />
                  찌든 뇌를 <b>브레인 샤워로 깨끗이</b> 씻어 줍니다!
                </p>
              </div>
              <div className="img">
                <img
                  src="../custom-resources/img/img_philosophy_phil03_img.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect phil04" id="happy">
            <div className="wrap">
              <div className="tit init">쾌(快) 학습</div>
              <div className="txt init">
                <p>
                  아이들은 흥미를 느낄 때 더 집중하고 호기심이 자극되어 사고력과
                  창의력이 커지게 됩니다. <br />
                  아소비는 아이들의 발달과 때에 맞는 맞춤 교육을 실시하여 아이
                  스스로 유쾌하고 상쾌하고 통쾌한 <br />
                  학습 향상의 기쁨을 느낄 수 있도록 도와줍니다.
                </p>
                <span>
                  재미있어서 <strong className="init">유쾌</strong>{" "}
                  <br className="mo-view" /> + <br className="mo-view" />
                  쉬워서 <strong className="init">상쾌</strong>
                  <br className="mo-view" /> + <br className="mo-view" />
                  빨리 알아서 <strong className="init">통쾌</strong>
                </span>
              </div>
              <div className="img mo-view">
                <img
                  src="../custom-resources/img/img_philosophy_phil04_mo_after.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect phil05" id="running">
            <div className="wrap">
              <div className="tit init">걷는 교육</div>
              <div className="txt init">
                <p>
                  아소비는 놀이 중심의 기어 다니는 유치 과정과 교과 중심의 읽고
                  쓰는 초등 과정의 <br /> 중간 단계인 걷는 과정이 빠져 있는 교육
                  현실을 고민했습니다. <br />
                  아소비는 중간 단계의 탄탄한 공부 방법을 알려주고 평생 공부
                  습관의 힘을 길러 줍니다.
                </p>
                <ul>
                  <li>
                    조금씩, 천천히! 아이의 걸음에 맞는{" "}
                    <span className="init">안전한 교육</span>
                  </li>
                  <li>
                    즐겁고 흥미롭게! 창의력을 키워 주는{" "}
                    <span className="init">건강한 교육</span>
                  </li>
                  <li>
                    하나를 배워도 제대로! 배우고 익히는{" "}
                    <span className="init">올바른 교육</span>
                  </li>
                </ul>
              </div>
              <div className="ico init">
                <img src="../custom-resources/img/img_zubi4.png" alt="" />
              </div>
              <div className="img mo-view">
                <img
                  src="../custom-resources/img/img_philosophy_phil05_img_mo.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect phil06">
            <div className="wrap">
              <div className="tit init">
                유기농공부 아소비가 <br />
                스스로 즐겁게 공부하는 힘! <span>학습생명력</span>을 키워줍니다.
              </div>
              <div className="txt">
                <ul className="diagram init">
                  <li>
                    특별한 <br />
                    학습 시스템
                  </li>
                  <li>
                    건강한 <br />
                    학습 습관
                  </li>
                  <li>공부 자신감</li>
                  <li>학습 성취감</li>
                  <li className="last">학습생명력</li>
                </ul>
              </div>
              <div className="img init">
                <img src="../custom-resources/img/img_zubi3.png" alt="" />
              </div>
            </div>
          </div>
          <div className="sect phil07">
            <div className="wrap">
              <div className="tit init">아소비는 왜 5~9세 인가요?</div>
              <div className="txt">
                <ul>
                  <li className="init">
                    <p>
                      아이의 두뇌는 <br />
                      5세에 뇌의 모든 부위에서 포도당 소모 수준이 이미 어른의
                      2배 정도가 되었다. <br />
                      9세가 될 때까지 지속되다 10세 이후 급속히 감소하는 것으로
                      볼 때 <br />
                      <b>두뇌 발달의 결정적 시기는 5세에서 9세로 볼 수 있다.</b>
                    </p>
                    <span>
                      - 해리 추가니(Harry Chugani)교수, 신경과학회 Ann Neural
                      논문 중
                    </span>
                  </li>
                  <li className="init">
                    <p>
                      추상적인 사고가 필요한 학습은 10세 이후부터 이루어져야
                      한다. <br />
                      <b>
                        10세 이전의 뇌가 왕성하게 활동할 때 추상적 학습을
                        시작하면 뇌 발달을 방해할 수 있다.
                      </b>
                    </p>
                    <span>
                      - 패트리샤 라키시(Patrica Goldman-Rakic)박사, 신경생리학회
                      논문 중
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="sect phil08 init">
            <div className="wrap">
              <div className="tit init">
                5~9세는 학습을 잘 할 수 있도록 하는 준비 단계입니다.{" "}
              </div>
              <div className="txt init">
                공부라는 긴 터널에서 오래 지치지 않고 잘 걸을 수 있게! <br />
                지식을 넣는 주입식 교육이 아닌 공부의 재미를 알게 해 주는 것이
                아주 중요합니다.
              </div>
            </div>
          </div>
          <div className="sect phil09">
            <div className="bg">
              <p>
                <span>
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부
                </span>
                <span>
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부
                </span>
              </p>
              <p>
                <span>
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부
                </span>
                <span>
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부 유기농공부 유기농공부
                  유기농공부 유기농공부 유기농공부
                </span>
              </p>
            </div>
            <div className="tit">
              아소비를 만난 아이들은 공부의 재미를 느끼며 행복하게 공부합니다.
            </div>
            <div className="img">
              <img
                src="../custom-resources/img/img_philosophy_phil09_img.png"
                className="pc-view"
                alt=""
              />
              <img
                src="../custom-resources/img/img_philosophy_phil09_img_mo.png"
                className="mo-view"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Philosophy;
